<script setup lang="ts">
import BaseModal from './BaseModal.vue';
import VKLoginPopup from '@/features/authByVK/ui/VKLoginPopup.vue';
import { useUserStore } from '@/entities/user/model/userStore';

const userStore = useUserStore();

const emit = defineEmits(['close', 'success']);

const close = () => {
  emit('close');
};

const handleSuccess = () => {
  emit('success');
  close();
};
</script>

<template>
  <BaseModal :is-open="true" title="Авторизация" @close="close" top-plush="/images/login_pic.webp">
    <VKLoginPopup v-if="!userStore.isLoading" @success="handleSuccess" />
    <div v-else class="loader-body">
      <div class="loader"></div>
      {{ userStore.getStateText }}
    </div>
  </BaseModal>
</template>
